export default __webpack_public_path__ + "static/media/CHEVRON_ICONA_DOWN.eb2886fe.svg";